import { Component, OnInit, OnDestroy } from '@angular/core';
import { CouponsectionService } from 'src/app/services/couponsection.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
// import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Observable, Observer } from "rxjs";

@Component({
  standalone: false,
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss']
})
export class BulkUploadComponent implements OnInit {

  formData: FormData;
  uploadFile: any;
  fileName: any;
  success: boolean;
  templateUrl: any;
  base64Image: any;

  constructor(
    private router: Router,
    private couponsectionService: CouponsectionService,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    // private appStateSrv: AppStateProvider
    private appStateSrv: AppStateProvider,
    private sideNavService: SidenavService,
  ) { }

  ngOnInit(): void {
    this.templateUrl = '';

    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');

    // this.subscriptions.unsubscribe();
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        // this.prepareTableData(JSON.parse(data));
        this.couponsectionService.setExcelData(data);
        this.router.navigate(['/preview-bulk-upload-coupon/']);
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });
  }

}
